import { Fragment, useState } from 'react';

import CloseIcon from '../../../../assets/imgs/icon/close.svg';
import { Flex } from '../../../../GlobalComponents/Flex';
import { Modal } from '../../../../GlobalComponents/Modal';
import IconButton from '../../../../GlobalComponents/IconButton';

import CardListView from '../components/CardListView';
import NewCardModal from '../components/NewCardModal';

const CardView = ({ cardDetails, primaryCard }: CardViewProps): JSX.Element => {
	const [showModal, setShowModal] = useState<boolean>(false);
	const [selectedCard, setSelectedCard] = useState<Card>({} as Card);

	const openCardView = (sortedCards: Card) => {
		setSelectedCard(sortedCards);
		toggleModel();
	};

	const toggleModel = () => {
		setShowModal(!showModal);
	};

	return (
		<Fragment>
			<Flex $flexDirection="column" $margin="0 0 24px 0" $height="unset">
				<CardListView
					cardDetails={cardDetails}
					onOpenCard={openCardView}
				/>
			</Flex>

			{/* Card Action Model */}
			<Fragment>
				<Modal isOpen={showModal} toggleHandler={toggleModel}>
					<Flex
						$flexDirection="row"
						$placeContent="center flex-end"
						$margin="0 0 24px 0"
					>
						<IconButton
							onClick={toggleModel}
							url={CloseIcon}
							alt={'close'}
						></IconButton>
					</Flex>
					<NewCardModal
						cardNumber={selectedCard?.card_number}
						balance={selectedCard?.cash}
						isPrimary={selectedCard?.default_payment_method}
						closeOnClick={toggleModel}
						primaryCard={primaryCard}
					></NewCardModal>
				</Modal>
			</Fragment>
		</Fragment>
	);
};

export default CardView;

interface CardViewProps {
	cardDetails: Card[];
	primaryCard?: Card;
}
